import {
    ButtonsOptions,
    ColorOptions,
    HorizontalAlignmentOptions,
    HtmlTagOptions,
    TextStyleOptions
} from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsComponentText } from './cms-component-text.interface';

export const CMS_COMPONENT_TEXT_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentText.ID,
    isAdvanced: true,
    name: 'Text',
    image: '/common/cms/text-component.png',
    tags: ['text', 'heading'],
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'type',
            type: NICmsContentField.EFieldType.choice,
            title: 'Type',
            options: [
                { key: 'text', title: 'Text Line' },
                { key: 'button', title: 'Button' }
            ],
            default: 'text'
        },
        <NICmsContentField.IChoiceField>{
            key: 'align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Alignment',
            options: HorizontalAlignmentOptions,
            default: 'center'
        },
        <NICmsContentField.ITextField>{
            key: 'text',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Copy',
            description: 'Text to display. HTML code can be used.',
            default: 'Lorem ipsum dolor',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'textColor',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Font color',
            default: 'white'
        },
        <NICmsContentField.ITextField>{
            key: 'cta_link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        },
        <NICmsContentField.IField>{
            key: 'cta_target',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Open in new tab'
        },
        // button
        <NICmsContentField.IChoiceField>{
            key: 'button_class',
            type: NICmsContentField.EFieldType.choice,
            title: 'Button Style',
            options: ButtonsOptions,
            default: ButtonsOptions[0] ? ButtonsOptions[0].key : undefined,
            canShow: (data: NCmsComponentText.IData) => data?.type === 'button'
        },
        // text
        <NICmsContentField.IChoiceField>{
            key: 'text_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Style',
            options: TextStyleOptions,
            default: 'h2',
            canShow: (data: NCmsComponentText.IData) => data?.type !== 'button'
        },
        <NICmsContentField.IChoiceField>{
            key: 'color',
            type: NICmsContentField.EFieldType.choice,
            colorPreview: true,
            title: 'Text Color',
            options: ColorOptions,
            default: '',
            canShow: (data: NCmsComponentText.IData) => data?.type !== 'button' || data?.button_class === 'button-inline'
        },
        <NICmsContentField.IChoiceField>{
            key: 'tag',
            type: NICmsContentField.EFieldType.choice,
            title: 'Force Tag',
            description: 'For SEO reasons you may want to force particular HTML tag',
            options: HtmlTagOptions,
            default: '',
            canShow: (data: NCmsComponentText.IData) => data?.type !== 'button'
        }
    ]
};
